import { Component } from '@angular/core';

@Component({
    selector: 'app-smartphones-unsupported',
    templateUrl: './smartphones-unsupported.component.html',
    styleUrls: ['./smartphones-unsupported.component.scss'],
    standalone: false
})
export class SmartphonesUnsupportedComponent {}
